import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, IMAGE_URL } from '../Component/Baseurl';
import defaultImage from './img/event1.jfif';  
import ban1 from './img/ban2.jpg';  
import { Link } from 'react-router-dom'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import usa from "./img/usa.jpg"; 
import uk from "./img/uk.png"; 
import germany from "./img/germany.png"; 
import uae from "./img/uae.png"; 
import canada from "./img/canada.png"; 
import australia from "./img/australia.png"; 
import india from "./img/india.jpg"; 
import china from "./img/china.jpg"; 
import france from "./img/france.jpg"; 
import netherlands from "./img/netherlands.png"; 
import singapore from "./img/singapore.png"; 
import japan from "./img/japan.jpg"; 


function PopularCountry() {
 
  return (
    <>
      <section className="bg-light pt-3 mb-5">
        <div className="row g-1">
            <div className="col-8">
              <h2 className="text-start hedng">Popular Country</h2>
            </div>
            <div className="col-4 text-end">
              <Link to="/filter/country/India" className="text-end viewall">
                View All <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </div>
          </div>

        <div className=" container-fluid">
          

          <div className="row g-3">
            <div className="col-md-2">
              <Link to="/filter/country/United States">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start me-2'>
                  <img src={usa} className='img-fluid cntryimg'/>
                </div>
                <h4 className='cdkl1'>USA</h4>
              </div>
              </Link>
            </div>

            <div className="col-md-2">
              <Link to="/filter/country/UK">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={uk} className='img-fluid cntryimg'/>
                   </div>
                <h4 className='cdkl1'>UK</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/country/Germany">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={germany} className='img-fluid cntryimg'/>
                  </div>
                <h4 className='cdkl1'>Germany</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/country/UAE">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={uae} className='img-fluid cntryimg'/>
                    </div>
                <h4 className='cdkl1'>UAE</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/country/Canada">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                   <img src={canada} className='img-fluid cntryimg'/>
                    </div>
                <h4 className='cdkl1'>Canada</h4>
              </div>
              </Link>
            </div>

            <div className="col-md-2">
              <Link to="/filter/country/Australia">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={australia} className='img-fluid  cntryimg'/>
                   </div>
                <h4 className='cdkl1'>Australia</h4>
              </div>
              </Link>
            </div>



            <div className="col-md-2">
              <Link to="/filter/country/India">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={india} className='img-fluid  cntryimg'/>
                   </div>
                <h4 className='cdkl1'>India</h4>
              </div>
              </Link>
            </div>



            <div className="col-md-2">
              <Link to="/filter/country/China">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={china} className='img-fluid  cntryimg'/>
                   </div>
                <h4 className='cdkl1'>China</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/country/France">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={france} className='img-fluid  cntryimg'/>
                   </div>
                <h4 className='cdkl1'>France</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/country/Netherlands">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={netherlands} className='img-fluid  cntryimg'/>
                   </div>
                <h4 className='cdkl1'>Netherlands</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/country/Singapore">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={singapore} className='img-fluid  cntryimg'/>
                   </div>
                <h4 className='cdkl1'>Singapore</h4>
              </div>
              </Link>
            </div>

            <div className="col-md-2">
              <Link to="/filter/country/Japan">
              <div className='cdgh d-flex justify-content-between align-items-center '>
                <div className='text-start'>
                  <img src={japan} className='img-fluid  cntryimg'/>
                   </div>
                <h4 className='cdkl1'>Japan</h4>
              </div>
              </Link>
            </div>


          </div>
        </div>
      </section>
    </>
  );
}

export default PopularCountry;
